import http from "../../../api/http";
import account from "../../../api/account";
import help from "../../../util/help";
// import md5 from 'js-md5'
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      periodical: [],
      position: [],
    };
  },
  computed: {
    ...mapGetters({
      loading: "getLoading",
      user: "getUser",
    }),
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
    // setTimeout(help.drawBackground('particle-canvas'), 0)
    this.updateLoading(false);

    document.onkeyup = (e) => {
      // 兼容FF和IE和Opera
      var event = e || window.event;
      var key = event.which || event.keyCode || event.charCode;
      if (key == 13 && this.$route.path === "/access/register") {
        this.login();
      }
    };
    // this.getPosition()
    // this.getPeriodical()
  },
  methods: {
    ...mapActions(["updateLoading", "updateUser"]),
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // const hash = md5(loginPass + 'ck');
          this.register(values);
        }
      });
    },
    register(data) {
      this.updateLoading(true);

      http.register(data).then((res) => {
        this.updateLoading(false);
        if (res && res.loginSuccess) {
          // if (res.type === 1) {
          this.$message.success("注册成功，3s后跳转登录", 3);
          setTimeout(() => {
            localStorage.removeItem("token");
            this.$router.push("/access/login");
          }, 3000);
          // this.$router.push('/workbench')
          // } else {
          //   this.msg = '账号权限不足！'
          // }
        } else if (res && res.errorMsg) {
          this.msg = res.errorMsg;
        }
      });
    },

    /**
     * 判斷兩次密碼輸入是否一致
     * @param {*} rule
     * @param {*} value
     * @param {*} callback
     */
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("两次密码输入的不一致!");
      } else {
        callback();
      }
    },

    // 获取职位信息
    getPosition() {
      account.position().then((res) => {
        this.position = res;
      });
    },

    // 获取期刊信息
    getPeriodical() {
      account.periodical().then((res) => {
        this.periodical = res;
      });
    },
  },
};
